import {setUserInfos} from '@/redux-store/slices/user-infos';
import keycloakAxios from '@/services/axios';
import {store} from '@/redux-store/store';
import {UserFormData} from '@/types/user';

export const updateUserData = async (updatedValues: UserFormData) => {
  const response = await keycloakAxios.post('user/update', updatedValues);

  if (response.status >= 300) {
    throw new Error(
      `Error updating user: Invalid status code: ${response.status}`
    );
  }

  let responseData = response.data;
  if (responseData.geolocation) {
    const location = {
      lat: responseData.geolocation.coordinates[1],
      lng: responseData.geolocation.coordinates[0],
      label: responseData.hometown
    };
    responseData = {
      ...responseData,
      location
    };
  }

  store.dispatch(setUserInfos(responseData));
  return responseData;
};
